  const formatTo12h = (time24: string) => {
    if (!time24) return "";
    const parts = time24.split(":");
    if (parts.length < 1) return time24;
    const hh = parseInt(parts[0] || "0", 10);
    const mm = parts[1] || "00";
    if (Number.isNaN(hh)) return time24;
    const period = hh >= 12 ? "PM" : "AM";
    let hour12 = hh % 12;
    if (hour12 === 0) hour12 = 12;
    return `${hour12}:${mm} ${period}`;
  };

export default formatTo12h;